module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-98e538ac8151051d7bf98232d67b8857.png";